import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col gap-20 w-full" }
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = { class: "mtop-02 w-full" }

import officeapi from '@/api/officeapi';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'addTaskBoxDirect',
  props: {
  healthGroupMemberships: {
    type: Array,
    required: true,
  }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emits = __emit

async function createTwoPersonTaskBox(healthGroupMember) {
  const appUserId = healthGroupMember.pwr.appUserId
  officeapi.createTwoPersonTaskBox(appUserId)
}

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal w-maxC",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.healthGroupMemberships, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (item.healthGroupMembers.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_text_item, {
                  txt: item.instituteWithRole.instituteShortName,
                  styles: "font-mBold main-l"
                }, null, 8, ["txt"]),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.healthGroupMembers, (item2, index) => {
                    return (_openBlock(), _createBlock(_component_listGroup2, {
                      key: index,
                      onClick: ($event: any) => (createTwoPersonTaskBox(item2))
                    }, {
                      default: _withCtx(() => [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mleft-04" }, null, -1)),
                        _createVNode(_component_text_item, {
                          txt: _unref(PersonService).formatName(item2.pwr.lastName, item2.pwr.firstName),
                          styles: "font-m main-h",
                          class: "pad-s"
                        }, null, 8, ["txt"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})